import axios from "axios";
import store from "../store/index.js";
import router from "../router.js";

let baseURL =
  process.env.NODE_ENV === "development"
      ? "http://123.207.84.50:8083/v1/"
      : "https://dgyz.cg1717.com/v1/";

// baseURL = "http://123.207.84.50:8083/v1/";
baseURL = 'https://dgyz.cg1717.com/v1';
// 默认配置
axios.defaults.baseURL = baseURL;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf8";
axios.defaults.timeout = 10000

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers.Authorization = store.state.token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    switch (response.data.code) {
      case 200:
        break;
      case 401:
        if (!router.history.current.meta.requireAuth) break;
        store.commit("logout");
        router.currentRoute.path !== "/user/login" &&
          router.replace({
            path: "/user/login",
            query: { redirect: router.currentRoute.fullPath }
          });
          return Promise.reject(response)
      default:
        if (!response.data.msg) response.data.msg = '网络异常, 请稍后重试'
        return Promise.reject(response)
    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit("logout");
          router.currentRoute.path !== "Login.vue" &&
            router.replace({
              path: "/login",
              query: { redirect: router.currentRoute.fullPath }
            });
      }
    }
    return Promise.reject(error);
  }
);
export default axios;
